module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "markerDialog",
    staticClass: "script-marker-dialog"
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', {
    staticClass: "md-has-select md-has-value"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.markerType),
      expression: "markerType"
    }],
    staticClass: "md-select md-theme-default",
    staticStyle: {
      "border": "none"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.markerType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    attrs: {
      "value": "act"
    }
  }, [_vm._v("Act")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    attrs: {
      "value": "scene"
    }
  }, [_vm._v("Scene")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    attrs: {
      "value": "song"
    }
  }, [_vm._v("Song")])])]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Label")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Scene 1"
    },
    model: {
      value: (_vm.markerLabel),
      callback: function($$v) {
        _vm.markerLabel = $$v
      },
      expression: "markerLabel"
    }
  })], 1), _vm._v(" "), (_vm.totalPages > 1) ? _c('md-input-container', {
    staticClass: "md-has-select md-has-value"
  }, [_c('label', [_vm._v("Page")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.markerPageIndex),
      expression: "markerPageIndex",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "md-select md-theme-default",
    staticStyle: {
      "border": "none"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.markerPageIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.totalPages), function(pageNum) {
    return _c('option', {
      key: pageNum,
      staticClass: "md-list-item md-menu-item md-option",
      domProps: {
        "value": pageNum
      }
    }, [_vm._v(_vm._s(_vm.pageLabel(pageNum)))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "marker-page-hint"
  }, [_vm._v(_vm._s(_vm.hintText))])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.saveLabel))]), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b886bbc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/markers/marker-dialog.vue
// module id = 1224
// module chunks = 21